import { styled, Tabs, TextTag, Text, TokenTextColor } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { CardetailsInterface } from '..';
import { getLang, getTranslations } from '../../../translations';
import FeatureSpecs from '../CarDetail/FeatureSpecs';
import TabContainer from './TabContainer';

export const SpecificationContainer = styled.div`
    // margin-top: var(--size-dynamic0150);
    @media screen and (min-width: 1040px) {
        grid-row: 4 / span 2;
    }
`;

const TabLabel = styled.div`
    color: #001E50
`;

interface SpecificationsInterface extends CardetailsInterface {}

interface TabInterface { title: JSX.Element, content: JSX.Element, key: string };

export default ({ vehicle }: SpecificationsInterface) => {
    const lang = getLang();
    const trans = getTranslations();
    const [tabs, setTabs] = useState<TabInterface[]>([] as TabInterface[]);

    const featureSpecs = vehicle?.feature_specs[lang];

    const featureSpecsHandler = () => {
        let tabsValue: TabInterface[] = featureSpecs?.map((feature, index) => {
            return {
                title: <TabLabel><Text color={TokenTextColor.inherit} tag={TextTag.span} bold>{feature.label ? feature.label : trans.details.details_overview}</Text></TabLabel>,
                content: <FeatureSpecs features={feature.values} />,
                key: 'specs-tab-' + index.toString()
            }
        }) || [] as TabInterface[];

        setTabs(tabsValue);
    }

    useEffect(() => {
        featureSpecsHandler();
    }, [featureSpecs]);

    return <SpecificationContainer>
            {
                tabs && tabs.length ?
                <TabContainer length={tabs.length}>
                    <Tabs
                        idPrefix="Details-Specification"
                        defaultIndex={0}>
                        { tabs }
                    </Tabs>
                </TabContainer> : null

            }
            </SpecificationContainer> ;
}
